var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b-link',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onUpdateClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.clock.Name))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.clock.CustomerName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.clock.ServiceContractDate)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7061e560","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clock/clock-list-row.vue
// module id = null
// module chunks = 